const menuItems = [
    {
        page: "Home",
        to: "/main",
    },
     {
        page: "Materials",
        to: "/materials",
    },
     {
        page: "Contacts",
        to: "/contacts",
    },
]

export default menuItems;